/**
 * @class away.sort.NullSort
 */
var RenderableNullSort = /** @class */ (function () {
    function RenderableNullSort() {
    }
    RenderableNullSort.prototype.sortBlendedRenderables = function (head) {
        return head;
    };
    RenderableNullSort.prototype.sortOpaqueRenderables = function (head) {
        return head;
    };
    return RenderableNullSort;
}());
export { RenderableNullSort };
